import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_AUCTION_BET_STEPS = 'AUCTION :: CHANGE_BET_STEPS';

interface IPayload {
  previousBets: number[];
  nextBets: number[];
}

export type TChangeAuctionBetStepsAction = IReduxAction<typeof CHANGE_AUCTION_BET_STEPS, IPayload>;

export const changeAuctionBetSteps = actionGenerator<typeof CHANGE_AUCTION_BET_STEPS, IPayload>(
  CHANGE_AUCTION_BET_STEPS,
);
